import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import Footer from '@/components/generals/footer'
import Nav from '@/components/generals/nav'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main'
                className='sr-only z-[60] rounded-lg border-2 border-ink bg-blaze px-4 py-3 font-heading font-bold text-ink focus:not-sr-only focus:fixed focus:left-4 focus:top-4'
            >
                Skip to content
            </a>

            <Nav />

            <main id='main' tabIndex={-1} className='flex-1 outline-none'>
                {children}
            </main>

            <Footer />
        </div>
    )
}
